module.exports = __webpack_public_path__ + "static/media/sand-clock.f4eda58e.svg";